var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.innerTo != null)?_c('v-btn',{attrs:{"to":_vm.innerTo,"target":_vm.target,"flat":_vm.flat,"depressed":_vm.depressed,"large":_vm.large,"block":_vm.block,"dark":_vm.dark,"color":_vm.color}},[_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }